import moment from "moment";
import Vue from 'vue';

class ShareService {
  constructor() {
    this.map = new Map();
  }
  onSuccessToast(message){
    Vue.prototype.$noty.success( message, {
      timeout: 2000,
      layout: "topCenter",
      theme: "semanticui",
    });
  }
  onErrorToast(message){
    Vue.prototype.$noty.error(message, {
      timeout: 2000,
      layout: "topCenter",
      theme: "semanticui",
    });
  }

  getDateObj(date ) {
    return new Date(date + " 00:00:00");
  }

  getMomentDate(date){
    if(date){
      var converted_date = moment(String(date)).format(
        "Y-MM-DD"
      );
    return converted_date;
    }

    return date;
  }
  currencyPos() {
    return "post";
  }
  setMapValue(key, value) {
    this.map.set(key, value);
  }

  getMapValue(key) {
    if (this.map.has(key)) {
      return this.map.get(key);
    } else {
      return null;
    }
  }

  leftPad(number) {
    var output = number + "";
    while (output.length < 6) {
      output = "0" + output;
    }
    return output;
  }

  clearMap() {
    this.map.clear();
  }

  deleteMapValue(key) {
    if (this.map.has(key)) {
      this.map.delete(key);
    }
  }
  removeAllPageData() {
    for (const [key, value] of this.map.entries()) {
      if (key.indexOf("page_") != -1) {
        this.deleteMapValue(key);
      }
    }
  }
}

export default new ShareService({
  map: new Map()
});



// WEBPACK FOOTER //
// ./src/service/ShareService.js